"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferenceAbilityHandler = exports.TransferenceActorAbilityFactory = exports.TransferenceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/effects/core");
class TransferenceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Transference;
        this.__typeName = "Transference";
    }
}
exports.TransferenceAbilityArgs = TransferenceAbilityArgs;
let TransferenceActorAbilityFactory = class TransferenceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Transference", "OneEnemies", 2);
    }
};
TransferenceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Transference")
], TransferenceActorAbilityFactory);
exports.TransferenceActorAbilityFactory = TransferenceActorAbilityFactory;
let TransferenceAbilityHandler = class TransferenceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 60)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.TransferenceEffectArgs(5 * invokerLevel, .5),
                    duration: Duration_1.Duration.Turns(8),
                    sequence
                });
            }
        });
    }
};
TransferenceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Transference)
], TransferenceAbilityHandler);
exports.TransferenceAbilityHandler = TransferenceAbilityHandler;
